function VehicleStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.vehicleForm.getStarted.policyStartDate',
		vehicles: [],
		'vehicles.0': '=_input.vehicleForm.carDetails',
		'vehicles.0.registrationState':
			'=_input.vehicleForm.aboutYourCar.regoDetails.state',
		'vehicles.0.garageType':
			'=_input.vehicleForm.carDetails.locationParked',
		'vehicles.0.afterMarketModifications':
			'=_input.vehicleForm.carDetails.modificationsBuilt',
		'vehicles.0.primaryUsage':
			'=_input.vehicleForm.carDetails.primaryCarUse',

		'vehicles.0.vin': '=_regoSearch.vin',
		'vehicles.0.drivers': [], //"=_input.vehicleForm.driver.drivers",
		'vehicles.0.vehicleInfo': '=_regoSearch',
		'vehicles.0.garageAddress': '=_addressSearch',

		'vehicles.0.excess.voluntaryVehicleExcess':
			'=_input.vehicleForm.insuredExcessValue.voluntaryVehicleExcess',

		policyHolders: [],
		'policyHolders.0': {},
		'policyHolders.0.mainHolder':
			'=_input.vehicleForm.mainPolicyHolder.mainPolicyHolder',
		'policyHolders.0.contact': '=_input.vehicleForm.mainPolicyHolder',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',

		// "policyHolders.0.contact.driverHistory": [],
		// "policyHolders.0.contact.driverHistory": "=_input.vehicleForm.mainPolicyHolder.fourYears_chargedOrConvictedOffencesDetails",

		policyAddress: '=_addressSearch',
		email: '=_input.email',
		campaignCode: '=_input.vehicleForm.promotionalCode.promotionalCode',
		mainContactAddress: '=_addressSearch-main-contact',
		postalAddress: '=_addressSearch-postal-address'
	};

	function updateVehicleDetails(transformedRequest, userInput) {
		transformedRequest.vehicles[0] = util.deepClone(
			transformedRequest.vehicles[0]
		);
		if (userInput.vehicleForm.insuredExcessValue) {
			transformedRequest.vehicles[0].sumInsuredType =
				userInput.vehicleForm.insuredExcessValue.comprehensivePref;
		}
		//userInput.vehicleForm.insuredExcessValue
		if (userInput.vehicleForm.carDetails) {
			transformedRequest.vehicles[0].purchasePrice =
				userInput.vehicleForm.carDetails.carCost;
			if (userInput.vehicleForm.carDetails.whenDidYouBuyYear) {
				transformedRequest.vehicles[0].purchaseMonthYear =
					userInput.vehicleForm.carDetails.whenDidYouBuyYear +
					'-' +
					userInput.vehicleForm.carDetails.whenDidYouBuyMonth;
			}

			if (!!userInput.vehicleForm.carDetails.businessActivityType) {
				transformedRequest.vehicles[0].businessUsage =
					userInput.vehicleForm.carDetails.businessActivityType;
			} else if (
				!!userInput.vehicleForm.carDetails.commercialActivityType
			) {
				transformedRequest.vehicles[0].businessUsage =
					userInput.vehicleForm.carDetails.commercialActivityType;
			}
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		if (userInput.vehicleForm.getStarted) {
			var personOrCompany =
				userInput.vehicleForm.getStarted.personOrCompany;
			if (personOrCompany == 'company')
				return updateCompanyContactDetails(
					transformedRequest,
					userInput
				);
			else
				return updatePersonContactDetails(
					transformedRequest,
					userInput
				);
		}

		return transformedRequest;
	}

	function updateCompanyContactDetails(transformedRequest, userInput) {
		var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

		if (
			userInput.vehicleForm.companyContact &&
			userInput.vehicleForm.aboutCompany
		) {
			// transformedRequest.email = userInput.vehicleForm.companyContact.email;
			// var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);
			policyHolder.contact = policyHolder.contact || {};
			policyHolder.contact.workPhone =
				userInput.vehicleForm.aboutCompany.officePhone;
			policyHolder.contact = Object.extend(
				policyHolder.contact,
				userInput.vehicleForm.aboutCompany
			);
			policyHolder.contact.emailAddress1 =
				userInput.vehicleForm.aboutCompany.email;
			policyHolder.contact.primaryAddress =
				userInput.vehicleForm.aboutCompany.companyAddress;

			var authorisedPerson = {};
			authorisedPerson = Object.extend(
				authorisedPerson,
				userInput.vehicleForm.companyContact
			);
			authorisedPerson.contactType = 'person';
			authorisedPerson.primaryAddress =
				transformedRequest.mainContactAddress !== null
					? transformedRequest.mainContactAddress
					: transformedRequest.vehicles[0].garageAddress;
			authorisedPerson.emailAddress1 =
				userInput.vehicleForm.companyContact.email;

			policyHolder.contact.passwordQuestion =
				authorisedPerson.passwordQuestion;
			policyHolder.contact.passwordAnswer =
				authorisedPerson.passwordAnswer;

			policyHolder.contact.authorisedPersons = [
				{
					person: authorisedPerson
				}
			];

			policyHolder.contact.primaryPhone = 'work';

			delete authorisedPerson.address;
			delete policyHolder.contact.companyAddress;
			delete policyHolder.contact.email;
			delete policyHolder.contact.officePhone;
		} else {
			policyHolder.contact.authorisedPersons = [
				{
					person: {
						contactType: 'person',
						primaryAddress: transformedRequest.policyAddress
					}
				}
			];
		}

		policyHolder.contact.contactType = 'company';
		transformedRequest.policyHolders[0] = policyHolder;
		transformedRequest.policyHolders[0].mainHolder = true;

		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.companyContact &&
			userInput.vehicleForm.companyContact
				.companyContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.vehicleForm.companyContact.companyContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.companyContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updatePersonContactDetails(transformedRequest, userInput) {
		var vehicleForm = userInput.vehicleForm,
			mainPolicyHolder = vehicleForm.mainPolicyHolder;

		if (mainPolicyHolder) {
			var policyHolders = [];
			mainPolicyHolder.policyContact =
				vehicleForm.mainPolicyHolderContact;
			if (mainPolicyHolder.isMainDriverMainPolicyHolder) {
				var driver = util.deepClone(
					transformedRequest.vehicles[0].drivers[0].driver
				);
				Object.extend(mainPolicyHolder, driver.person);
			}

			policyHolders.push(mainPolicyHolder);
			if (
				vehicleForm.additionalPolicyHolders &&
				vehicleForm.additionalPolicyHolders.policyHolders
			) {
				policyHolders = policyHolders.concat(
					vehicleForm.additionalPolicyHolders.policyHolders
				);
			}

			policyHolders.forEach(function(policyHolder, index) {
				var contact = util.deepClone(policyHolder);
				if (!transformedRequest.policyHolders[index])
					transformedRequest.policyHolders[index] = {};

				var transformedContact =
					transformedRequest.policyHolders[index];
				if (!contact.contactType)
					contact.contactType =
						'person'; /* TODO : check to make sure this condition is always safe to use */

				contact.prefix = contact.title;

				if (contact.policyContact) {
					Object.extend(contact, contact.policyContact);
					if (contact.primaryPhone == 'mobile')
						contact.cellPhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'home')
						contact.homePhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'work')
						contact.workPhone = contact.primaryPhoneNumber;

					delete contact.policyContact;
				}

				if (!contact.primaryAddress)
					contact.primaryAddress = util.clone(
						mainPolicyHolder.primaryAddress
					);

				if (index == 0) {
					if (!contact.isMainDriverMainPolicyHolder) {
						if (
							contact.fourYears_chargedOrConvictedOffences &&
							(!contact.fourYears_chargedOrConvictedOffencesDetails ||
								contact
									.fourYears_chargedOrConvictedOffencesDetails
									.length < 1)
						) {
							contact.fourYears_chargedOrConvictedOffences = false;
						}

						if (
							contact.fourYears_vehicleAccidentsClaims &&
							(!contact.fourYears_vehicleAccidentsClaimsDetails ||
								contact.fourYears_vehicleAccidentsClaimsDetails
									.length < 1)
						) {
							contact.fourYears_vehicleAccidentsClaims = false;
						}

						if (
							contact.fourYears_licenceRSDC &&
							(!contact.fourYears_licenceRSDCDetails.length ||
								contact.fourYears_licenceRSDCDetails.length < 1)
						) {
							contact.fourYears_licenceRSDC = false;
						}

						if (
							contact.tenYears_chargedOrConvictedOffences &&
							(!contact.tenYears_chargedOrConvictedOffencesDetails ||
								contact
									.tenYears_chargedOrConvictedOffencesDetails
									.length < 1)
						) {
							contact.tenYears_chargedOrConvictedOffences = false;
						}

						contact.drivingHistory = [];

						if (contact.fourYears_chargedOrConvictedOffences) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_chargedOrConvictedOffencesDetails.slice()
							);
						}

						if (contact.fourYears_vehicleAccidentsClaims) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_vehicleAccidentsClaimsDetails.slice()
							);
						}

						if (contact.fourYears_licenceRSDC) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.fourYears_licenceRSDCDetails.slice()
							);
						}

						if (contact.tenYears_chargedOrConvictedOffences) {
							contact.drivingHistory = contact.drivingHistory.concat(
								contact.tenYears_chargedOrConvictedOffencesDetails.slice()
							);
						}

						contact.drivingHistory.forEach(function(dh) {
							if (dh.description) {
								dh.pattern = {
									publicID: '',
									description: '',
									code: '',
									filter1: ''
								};
								dh.pattern.publicID = dh.description.publicID;
								dh.pattern.description = dh.description.label;
								dh.pattern.code = dh.description.code;
								dh.pattern.filter1 = dh.description.filter1;

								dh.month = transposeMonth(dh.month.value);
								dh.year = dh.year.value;

								delete dh.description;
							}
						});
					}
				} else {
					if (
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences &&
						(!contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails ||
							contact
								.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences = false;
					}

					if (
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims &&
						(!contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails ||
							contact
								.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims = false;
					}

					if (
						contact.additionalPolicyHolderFourYears_licenceRSDC &&
						(!contact
							.additionalPolicyHolderFourYears_licenceRSDCDetails
							.length ||
							contact
								.additionalPolicyHolderFourYears_licenceRSDCDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderFourYears_licenceRSDC = false;
					}

					if (
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences &&
						(!contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails ||
							contact
								.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails
								.length < 1)
					) {
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences = false;
					}

					contact.drivingHistory = [];

					if (
						contact.additionalPolicyHolderFourYears_chargedOrConvictedOffences
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_chargedOrConvictedOffencesDetails.slice()
						);
					}

					if (
						contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_vehicleAccidentsClaimsDetails.slice()
						);
					}

					if (contact.additionalPolicyHolderFourYears_licenceRSDC) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderFourYears_licenceRSDCDetails.slice()
						);
					}

					if (
						contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences
					) {
						contact.drivingHistory = contact.drivingHistory.concat(
							contact.additionalPolicyHolderTenYears_chargedOrConvictedOffencesDetails.slice()
						);
					}

					contact.drivingHistory.forEach(function(dh) {
						if (dh.description) {
							dh.pattern = {
								publicID: '',
								description: '',
								code: '',
								filter1: ''
							};
							dh.pattern.publicID = dh.description.publicID;
							dh.pattern.description = dh.description.label;
							dh.pattern.code = dh.description.code;
							dh.pattern.filter1 = dh.description.filter1;

							dh.month = transposeMonth(dh.month.value);
							dh.year = dh.year.value;

							delete dh.description;
						}
					});
				}

				contact.hasClaim =
					contact.fourYears_vehicleAccidentsClaims ||
					contact.additionalPolicyHolderFourYears_vehicleAccidentsClaims ||
					false;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences ||
					contact.additionalPolicyHolderTenYears_chargedOrConvictedOffences ||
					false;

				if (!transformedContact.contact)
					transformedContact.contact = {};
				Object.extend(transformedContact.contact, contact);
			});
		} else if (
			transformedRequest.vehicles[0].drivers[0] &&
			transformedRequest.vehicles[0].drivers[0].driver &&
			transformedRequest.vehicles[0].drivers[0].driver.person
		) {
			var driver = transformedRequest.vehicles[0].drivers[0].driver;
			var contact = transformedRequest.policyHolders[0].contact;
			Object.extend(contact, driver.person);
			contact.contactType =
				'person'; /* TODO : check to make sure this condition is always safe to use */
		}
		transformedRequest.policyHolders[0].mainHolder = true;
		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				userInput.vehicleForm &&
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.vehicleForm.mainPolicyHolderContact &&
				userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
			}
		} else {
			if (
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.mainPolicyHolderContact &&
			userInput.vehicleForm.mainPolicyHolderContact
				.personalContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.vehicleForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.personalContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updateDrivers(transformedRequest, userInput) {
		transformedRequest.vehicles[0].drivers = [];
		if (
			userInput.vehicleForm.driver &&
			userInput.vehicleForm.driver.drivers
		) {
			userInput.vehicleForm.driver.drivers.forEach(function(driver) {
				driver.person.contactType = 'person';
				driver.person.prefix = driver.person.title;
				driver.hasClaim = driver.person.hasClaim =
					driver.fourYears_vehicleAccidentsClaims;
				driver.hasInfringement =
					driver.fourYears_chargedOrConvictedOffences;
				driver.hasLostLicence = driver.fourYears_licenceRSDC;
				driver.hasConviction = driver.person.hasConviction =
					driver.tenYears_chargedOrConvictedOffences;
				driver.zeroDemerits = driver.NSWDemeritPoints;
				//driver.yearsLicenced = driver.yearsHeld ;

				driver.person.primaryAddress = transformedRequest.policyAddress;
				driver.person.primaryAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';

				switch (driver.yearsHeld) {
					case 'lessThan_1':
						driver.yearsLicenced = '7';
						break;
					case 'greaterThan_5':
						driver.yearsLicenced = '6';
						break;
					default:
						driver.yearsLicenced = driver.yearsHeld;
				}

				if (
					driver.fourYears_chargedOrConvictedOffences &&
					(!driver.fourYears_chargedOrConvictedOffencesDetails ||
						driver.fourYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_vehicleAccidentsClaims &&
					(!driver.fourYears_vehicleAccidentsClaimsDetails ||
						driver.fourYears_vehicleAccidentsClaimsDetails.length <
							1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_licenceRSDC &&
					(!driver.fourYears_licenceRSDCDetails.length ||
						driver.fourYears_licenceRSDCDetails.length < 1)
				) {
					driver.fourYears_licenceRSDC = false;
				}

				if (
					driver.tenYears_chargedOrConvictedOffences &&
					(!driver.tenYears_chargedOrConvictedOffencesDetails ||
						driver.tenYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.tenYears_chargedOrConvictedOffences = false;
				}

				driver.driverHistory = [];

				if (driver.fourYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				if (driver.fourYears_vehicleAccidentsClaims) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				if (driver.fourYears_licenceRSDC) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_licenceRSDCDetails.slice()
					);
				}

				if (driver.tenYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				driver.driverHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				var driverObj = {
					driver: driver
				};

				// var toDelete = isItemMarkedForDelete('driver', driver) ;
				// if (toDelete) driverObj.markedForDelete = true ;

				transformedRequest.vehicles[0].drivers.push(driverObj);
			});

			transformedRequest.vehicles[0].drivers[0].driverUsage = 'main';
		} else {
			transformedRequest.vehicles[0].drivers = [
				{
					driverUsage: 'main'
				}
			];
		}

		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				angular.isDefined(
					transformedRequest.vehicles[0].drivers[0].driver
				)
			) {
				if (
					userInput.vehicleForm.tellUsABitMore &&
					userInput.vehicleForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.vehicleForm.mainPolicyHolderContact &&
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.email;
				}
			}
		} else {
			if (
				userInput.vehicleForm.tellUsABitMore &&
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress
			) {
				if (
					transformedRequest.vehicles[0].drivers[0].driver.person
						.emailAddress1
				) {
					//use the existing if available
				} else {
					transformedRequest.vehicles[0].drivers[0].driver.person.emailAddress1 =
						userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		return transformedRequest;
	}

	function updateVehicleRegoDetails(transformedRequest, userInput) {
		var aboutYourCar = userInput.vehicleForm.aboutYourCar,
			tellUsYourRegoNumber = userInput.vehicleForm.tellUsYourRegoNumber,
			regoNumber = null;

		if (aboutYourCar && aboutYourCar.regoDetails) {
			regoNumber = aboutYourCar.regoDetails.regoNumber;
		} else if (tellUsYourRegoNumber && tellUsYourRegoNumber.regoNumber) {
			regoNumber = tellUsYourRegoNumber.regoNumber;
		}

		transformedRequest.vehicles[0].registrationNumber = regoNumber;
		return transformedRequest;
	}

	function updateAdditionalDrivers(transformedRequest, userInput) {
		var fromRapidEstimate = !userInput.fromFullQuote,
			driver = userInput.vehicleForm.driver,
			drivers = driver ? driver.drivers : null,
			/** required for when checking decline on step 1 */
			youngestDriver = null;

		if (!driver) return transformedRequest;

		var rapidEstimateYoungerDriver =
			fromRapidEstimate &&
			driver.youngestDriver &&
			driver.numberOfOtherDrivers > 0;
		if (!rapidEstimateYoungerDriver)
			youngestDriver = findYoungestDriver(drivers);

		transformedRequest.vehicles[0].youngestDriverGender = rapidEstimateYoungerDriver
			? driver.youngestDriverGender /** value from rapid estimate */
			: youngestDriver
			? youngestDriver.person.gender
			: null; /** value from full quote */

		transformedRequest.vehicles[0].otherDriverHasProLicense = fromRapidEstimate
			? driver.provisionalLicence /** value from rapid estimate */
			: youngestDriver
			? youngestDriver.licenceType == 'provisional'
			: false; /** value from full path */

		transformedRequest.vehicles[0].youngestDriverDOB = rapidEstimateYoungerDriver
			? driver.youngestDriverDob
			: youngestDriver
			? youngestDriver.person.dateOfBirth
			: null;

		transformedRequest.vehicles[0].otherDriverUsageTimes = fromRapidEstimate
			? numberOfOtherDrivers(
					driver.numberOfOtherDrivers
			  ) /* value from rapid estimate */
			: drivers.length - 1; /* value from full quote */

		return transformedRequest;
	}

	function numberOfOtherDrivers(num) {
		return num == 6 ? '5plus' : '' + num;
	}

	function updateMainDriverAddress(transformedRequest, userInput) {
		var phs = transformedRequest.policyHolders,
			ph = phs ? phs[0] : null,
			contact = ph ? ph.contact : null,
			phAddress = contact ? contact.primaryAddress : null;

		phAddress = phAddress || transformedRequest.policyAddress;

		return applyAddressForGoodDriverBonus(transformedRequest, phAddress);
	}

	/**
	 * setting the policy contact address on the main driver.
	 * This is required for good driver bonus discount to come through
	 */
	function applyAddressForGoodDriverBonus(transformedRequest, address) {
		if (
			transformedRequest.vehicles[0].drivers[0] &&
			transformedRequest.vehicles[0].drivers[0].driver &&
			transformedRequest.vehicles[0].drivers[0].driver.person
		) {
			transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress = address;

			if (
				transformedRequest.vehicleForm.getStarted.personOrCompany ===
					'company' &&
				transformedRequest.postalAddress !== null
			) {
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress =
					transformedRequest.postalAddress;
			}
			if (angular.isDefined(transformedRequest.vehicleForm)) {
				/****************************************************************************
				 * address is default to be residential to enable good driver bonus discount
				 * Check Transformed request if come from vehicle form
				 * Added Fallback to use the default values as residential
				 ***************************************************************************/
				// Added checking for business Address Type to be able to include to good driver discount
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';
			} else {
				transformedRequest.vehicles[0].drivers[0].driver.person.primaryAddress.addressType =
					'residential';
			}
		} else {
			if (angular.isDefined(transformedRequest.vehicleForm)) {
				// Replace Address Type via personOrCompany value
				transformedRequest.policyAddress.addressType =
					transformedRequest.vehicleForm.getStarted
						.personOrCompany === 'company'
						? 'business'
						: 'residential';
			}
		}

		if (transformedRequest.postalAddress !== null) {
			transformedRequest.postalAddress.addressType = transformedRequest.policyAddress.addressType =
				'postal';
		}
		return transformedRequest;
	}

	function findYoungestDriver(drivers) {
		var youngest = null;
		drivers.forEach(function(driver) {
			if (!youngest) youngest = driver;
			else if (isYounger(driver, youngest)) youngest = driver;
		});

		function isYounger(driver, otherDriver) {
			return (
				moment(driver.person.dateOfBirth, 'DD/MM/YYYY') >
				moment(otherDriver.person.dateOfBirth, 'DD/MM/YYYY')
			);
		}

		return youngest;
	}

	function updateVehicleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		var insuredExcessValue = userInput.vehicleForm.insuredExcessValue;
		if (insuredExcessValue) {
			transformedRequest.vehicles[0].sumInsuredType =
				insuredExcessValue.comprehensivePref;
			if (insuredExcessValue.comprehensivePref == 'agreed') {
				transformedRequest.vehicles[0].sumInsuredAmount =
					insuredExcessValue.agreedValue;
			} else if (quoteOptions.getSelectedQuoteResult()) {
				transformedRequest.vehicles[0].sumInsuredAmount = quoteOptions
					.getSelectedQuoteResult()
					.getAnnual().vehicleValue.lower;
			}
		}
		return transformedRequest;
	}

	function updateVehicleInsuranceOptionalBenefits(
		transformedRequest,
		userInput
	) {
		var optionalBenefits = userInput.vehicleForm.optionalBenefits;
		var coverageOptions = [];
		if (optionalBenefits) {
			for (var key in optionalBenefits) {
				coverageOptions.push({
					name: key,
					selected: optionalBenefits[key],
					required: false
				});
			}
			transformedRequest.vehicles[0].coverageOptions = coverageOptions;
		}
		return transformedRequest;
	}

	function updateModificationOptions(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails;

		if (carDetails) {
			var modifications = carDetails.modifications;

			if (modifications) {
				var mods = carDetails.modificationsOptions,
					vehicleInfo = transformedRequest.vehicles[0].vehicleInfo;

				if (mods && vehicleInfo && vehicleInfo.optionalEquipments) {
					var selectedEquipments = vehicleInfo.optionalEquipments.slice();
					var modsKeys = Object.keys(mods);
					// need to do a look up to find code,optionKey and description from optionalEquipments
					selectedEquipments = selectedEquipments.filter(function(
						eq
					) {
						return modsKeys.indexOf(eq.optionKey) !== -1;
					});
					vehicleInfo.selectedEquipments = selectedEquipments;
				}
			}
		}

		return transformedRequest;
	}

	function updateAfterMarketModifications(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails;
		if (carDetails) {
			var modificationsBuilt = carDetails.modificationsBuilt;

			if (modificationsBuilt) {
				var mods = carDetails.modificationsBuiltOptions;

				if (mods) {
					afterMarketMods = [];

					for (var key in mods) {
						if (mods[key] === true) {
							afterMarketMods.push(key);
						}
					}
					transformedRequest.vehicles[0].afterMarketMods = afterMarketMods;
				}
			}
		}
		return transformedRequest;
	}

	function updateExistingDamage(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			existingDamage = carDetails ? carDetails.existingDamage : null;

		if (existingDamage) {
			transformedRequest.vehicles[0].unrepairedDamage = existingDamage;
			if (existingDamage != 'none') {
				/** do we have to set this to agree and set sumInsured to Salvage value ??? */
				if (carDetails.salvageValue) {
					transformedRequest.vehicles[0].sumInsuredType = 'agreed';
					transformedRequest.vehicles[0].sumInsured =
						carDetails.salvageValue;
					transformedRequest.vehicles[0].evidenceOfValueOrPrice =
						carDetails.writtenEvidence;
				}
			}
		}

		return transformedRequest;
	}

	function updateFinanceType(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			carFinance = carDetails ? carDetails.carFinance : 'none';
		// , financeWith = carDetails.financeWith ? carDetails.financeWith : null;

		if (carDetails) {
			if (carDetails.financeWith) {
				financeWith = carDetails.financeWith;
			} else {
				financeWith = null;
			}
		} else {
			financeWith = null;
		}

		if (carFinance) {
			transformedRequest.vehicles[0].financeType = carFinance;

			if (
				financeWith &&
				financeWith.hasOwnProperty('label') &&
				financeWith.hasOwnProperty('value')
			) {
				transformedRequest.vehicles[0].financeCompany = {};

				transformedRequest.vehicles[0].financeCompany.name =
					financeWith.label;
				transformedRequest.vehicles[0].financeCompany.publicID =
					financeWith.value;
			}
		}

		return transformedRequest;
	}

	function updateRecentPurchase(transformedRequest, userInput) {
		var carDetails = userInput.vehicleForm.carDetails,
			last12Months = carDetails ? carDetails.last12Months : false,
			carCost = last12Months ? carDetails.carCost : null;

		if (last12Months) {
			transformedRequest.vehicles[0].recentPurchase = last12Months;

			if (carCost) {
				transformedRequest.vehicles[0].purchasePrice = carCost;
			}
		}

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.tellUsABitMore &&
			userInput.vehicleForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.vehicleForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.vehicleForm &&
				userInput.vehicleForm.mainPolicyHolderContact &&
				userInput.vehicleForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.vehicleForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		// send the campaign code to GW
		if (
			userInput.vehicleForm &&
			userInput.vehicleForm.tellUsABitMore &&
			userInput.vehicleForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.vehicleForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	function updateStampDutyEligibility(transformedRequest, userInput) {
		var stampDutyEligible = storage.getItem('stamp-duty');
		if (userInput.vehicleForm.stampDutyExemption && stampDutyEligible) {
			transformedRequest.vehicles[0].isSmallBusiness =
				userInput.vehicleForm.stampDutyExemption.isSmallBusiness;
		} else {
			delete transformedRequest.vehicles[0].isSmallBusiness;
		}
		return transformedRequest;
	}

	// function isItemMarkedForDelete(typeName, item) {
	// 	var toRemove = aggregatedRemoveService.getList();
	// 	var itemsToRemove = toRemove[typeName] || [];
	// 	var removeItem = false ;
	// 	itemsToRemove.some(function(itemToRemove) {
	// 		if ( itemToRemove._aggregator.id == item._aggregator.id){
	// 			removeItem = true;
	// 			return;
	// 		}
	// 	});
	// 	return removeItem;
	// }

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem('policy-address');

		if (
			angular.isDefined(userInput.vehicleForm.mainPolicyHolderContact) ||
			angular.isDefined(userInput.vehicleForm.companyContact)
		) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				var isPostalOption = true;
				if (
					userInput.vehicleForm.getStarted.personOrCompany == 'person'
				) {
					isPostalOption =
						userInput.vehicleForm.mainPolicyHolderContact
							.postalOption;
				} else {
					isPostalOption =
						userInput.vehicleForm.companyContact.postalOption;
				}

				if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}

		delete transformedRequest.postalAddress;
		delete transformedRequest.mainContactAddress;
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = updateVehicleDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleRegoDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateStampDutyEligibility(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDrivers(transformedRequest, userInput);
		transformedRequest = updateAdditionalDrivers(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);
		transformedRequest = updateMainDriverAddress(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceTypeAndAmount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceOptionalBenefits(
			transformedRequest,
			userInput
		);
		transformedRequest = updateAfterMarketModifications(
			transformedRequest,
			userInput
		);
		transformedRequest = updateModificationOptions(
			transformedRequest,
			userInput
		);
		transformedRequest = updateExistingDamage(
			transformedRequest,
			userInput
		);
		transformedRequest = updateFinanceType(transformedRequest, userInput);
		transformedRequest = updateRecentPurchase(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}
